module.exports = __webpack_public_path__ + "img/brand guidelines.d902337f.svg";